import React from 'react'
import { FormattedHTMLMessage, FormattedCurrency } from '@web/walter-ui-kit'

import { GetProducts } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'

interface Props {
    data?: GetProducts
    type?: 'primary' | 'secondary' | 'tertiary' | 'quadro'
}

// eslint-disable-next-line complexity,max-lines-per-function
function Fee({ data, type = 'primary' }: Props) {
    const topupFees = data?.fees?.topup

    return (
        <div className={s[type]}>
            <div className={s.content}>
                {data?.fees?.issuance?.fixed && (
                    <div className={s.row}>
                        <FormattedHTMLMessage {...lang.issueCost} className={s.title} />
                        <span className={s.text}>
                            <FormattedCurrency
                                maxPrecision={2}
                                value={data?.fees?.issuance?.fixed}
                                currency={data?.fees?.issuance?.currency}
                                dataPointer="min_fee"
                            />
                        </span>
                    </div>
                )}
                {data?.fees?.monthly?.fixed && (
                    <div className={s.row}>
                        <FormattedHTMLMessage {...lang.monthFee} className={s.title} />
                        <span className={s.text}>
                            <FormattedCurrency
                                maxPrecision={2}
                                value={data?.fees?.monthly?.fixed}
                                currency={data?.fees?.monthly?.currency}
                                dataPointer="min_fee"
                            />
                        </span>
                    </div>
                )}
                {(topupFees?.fixed || topupFees?.percent) && (
                    <div className={s.row}>
                        <FormattedHTMLMessage {...lang.topUpFee} className={s.title} />
                        <div className={s.fee}>
                            <span className={s.text}>
                                <FormattedCurrency
                                    maxPrecision={2}
                                    value={topupFees?.fixed}
                                    currency={topupFees?.currency}
                                    dataPointer="min_fee"
                                />
                                {topupFees?.fixed && topupFees?.percent ? ' + ' : undefined}
                                {topupFees?.percent}
                                {topupFees?.percent ? '%' : ''}
                            </span>
                            <span className={s.minMaxText}>
                                {topupFees?.min ? (
                                    <>
                                        <FormattedHTMLMessage {...lang.min} />{' '}
                                        <FormattedCurrency
                                            maxPrecision={2}
                                            value={topupFees?.min}
                                            currency={data?.currency}
                                            dataPointer="min_fee"
                                        />
                                    </>
                                ) : undefined}
                                {topupFees?.min && topupFees?.max ? ', ' : undefined}
                                {topupFees?.max ? (
                                    <>
                                        <FormattedHTMLMessage {...lang.max} />{' '}
                                        <FormattedCurrency
                                            maxPrecision={2}
                                            value={topupFees?.max}
                                            currency={data?.currency}
                                            dataPointer="max_fee"
                                        />
                                    </>
                                ) : undefined}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export { Fee }
